import React from 'react';
import { useManpowerBar } from '../data';
import BarComponent from './BarComponent';
import ChartLoading from './ChartLoading';
import { BAR_CHART, PIE_CHART, useChartData } from './config';
import PieComponent from './PieComponent';

const Manpower = ({ loading, manpower }) => {
  const { manpowerBar } = useManpowerBar();
  const data = useChartData({ data: manpower, type: PIE_CHART, label: 'Manpower' });
  const barData = useChartData({ data: manpowerBar, type: BAR_CHART, label: 'Manpower' });
  return (
    <>
      {loading ? <ChartLoading /> : <PieComponent data={data} />}
      {/* <hr />
      Manpower Tertinggi Perusahaan
      {loading ? <ChartLoading /> : <BarComponent data={barData} />} */}
    </>
  );
}

export default Manpower;